import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {
    createForumComment,
    deleteForumComment,
    fetchForumComment,
    resetForumComment,
    updateForumComment
} from "../../../../creators/forums.comment";

import {Button} from "../../../components/Button";
import {CheckboxInputField, TextAreaField} from "../../../components/FormField";
import Modal from "../../../components/Modal";
import Alert from "../../../components/Alert";
import MkEditor from "../../../components/editor/Editor";
import {Can} from "../../../../ability-context";

class EditComment extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            editComment: {
                contentRaw: {},
                edit: {
                    displayMessage: false,
                    reason: "",
                },
                updatedAt: Date.now(),
                useSign: this.props.commentId ? this.props.forumComment.useSign : this.props.currentUser.setting.signature.display
            },
            toggleAlertDelete: false,
        };
        this.handleEditComment = this.handleEditComment.bind(this);
        this.handleEditCommentEdit = this.handleEditCommentEdit.bind(this);
        this.deleteComment = this.deleteComment.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.props.resetForumComment();
        if(this.props.commentId){
            this.props.fetchForumComment(this.props.forumId, this.props.topicId, this.props.commentId);
        }
    }

    componentWillUnmount() {
        this.props.resetForumComment();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.forumComment !== this.props.forumComment && this.props.forumCommentInitialized){
            this.setState({editComment: {
                    ...this.state.editComment,
                    contentRaw: this.props.forumComment.contentRaw,
                    edit: {
                        displayMessage: this.props.forumComment.edit.displayMessage,
                        reason: this.props.forumComment.edit.reason,
                    },
                    useSign: this.props.commentId ? this.props.forumComment.useSign : this.props.currentUser.setting.signature.display
                }});
        }
    }

    handleEditComment(name, value){
        this.setState({editComment: {...this.state.editComment, [name]: value}});
    }

    handleEditCommentEdit(name, value){
        this.setState({editComment: {...this.state.editComment, edit: {...this.state.editComment.edit, [name]: value}}});
    }

    deleteComment() {
        this.props.deleteForumComment(this.props.forumId, this.props.topicId, this.props.commentId);
        this.setState({toggleAlertDelete: false});
    }

    handleSubmit(){
        // let files = {};
        // let contentRaw = this.state.editComment.contentRaw;
        // if(this.state.editComment && this.state.editComment.contentRaw.entityMap){
            // files = {
            //     ...files,
            //     "contentRaw.entityMap" : Object.values(this.state.article.contentRaw.entityMap)
            // };
            // let contentFiles = Object.values(this.state.editComment.contentRaw.entityMap);
            // contentFiles.forEach((item,index) =>{
            //     if(item.type === "UPLOADED_MEDIA" && item.data.id){
            //         let key = `contentRaw.entityMap[${index}].data.uri`;
            //         files = {
            //             ...files,
            //             [key] : item.data.id
            //         }
            //         if(contentRaw.entityMap[index].data && contentRaw.entityMap[index].data.id){
            //             delete contentRaw.entityMap[index].data.id;
            //         }
            //     }
            // });

        // }
        if(this.props.commentId){
            this.props.updateForumComment(this.props.forumId, this.props.topicId, this.props.commentId, this.state.editComment);
        } else {
            this.props.createForumComment(this.props.forumId, this.props.topicId, this.state.editComment);
        }
        this.props.handleClose();
    }

    handleEditorChange(content){
        this.setState({editComment: {...this.state.editComment, contentRaw: content}});
    }

    render(){
        return (
            <div className={"modal-container edit-comment"}>
                <div className={"modal-topline"}>
                    {this.props.commentId ? "Editer la réponse" : `Répondre à : ${this.props.title}`}
                </div>
                <div className={"modal-body"}>
                    <div className={"block"}>
                        {this.props.commentId && this.props.forumCommentInitialized && (
                            <MkEditor kind={"topicComments"} onChange={this.handleEditorChange}
                                      defaultValue={this.state.editComment.contentRaw}/>
                        )}
                        {!this.props.commentId && (
                            <MkEditor kind={"topicComments"} onChange={this.handleEditorChange}/>
                        )}
                    </div>
                    {!this.props.createMessage && (
                        <Can action={"moderation"} subject={this.props} modelName="TopicComment">
                            <div className={"block"}>
                                <CheckboxInputField checked={this.state.editComment.edit.displayMessage}
                                                    label={"Afficher la raison de l'edition ?"}
                                                    htmlFor={"displayMessage"}
                                                    id={"displayMessage"}
                                                    onChange={()=>this.handleEditCommentEdit("displayMessage", !this.state.editComment.edit.displayMessage)}/>
                                {this.state.editComment.edit.displayMessage && (
                                    <TextAreaField value={this.state.editComment.edit.reason}
                                                   placeholder={"Pour quel raison avez-vous édité cette réponse ?"}
                                                   onChange={(event)=>this.handleEditCommentEdit("reason", event.target.value)} />
                                )}
                            </div>
                        </Can>
                    )}
                    <div className={"block"}>
                        <CheckboxInputField checked={this.state.editComment.useSign}
                                            label={"Afficher votre signature sur ce message ?"}
                                            htmlFor={"useSign"}
                                            id={"useSign"}
                                            onChange={()=>this.handleEditComment("useSign", !this.state.editComment.useSign)}/>
                    </div>
                </div>
                <div className={"modal-baseline"}>
                    <Button btnStyle={"grey"}
                            size={"small"}
                            onClick={()=>this.props.handleClose()}
                            content={"Annuler"}/>
                    {!this.props.createMessage && (
                        <Button btnStyle={"cancel-reverse"}
                                size={"small"}
                                onClick={()=>this.setState({toggleAlertDelete: true})}
                                content={"Supprimer"}/>
                    )}
                    <Button btnStyle={"primary-reverse"}
                            size={"small"}
                            onClick={()=>this.handleSubmit()}
                            content={"Enregistrer"}/>
                </div>
                <Modal toggle={this.state.toggleAlertDelete} handleClose={()=>this.setState({toggleAlertDelete: false})}>
                    <Alert text="Voulez-vous vraiment supprimer cette réponse"
                           handleClose={() => this.setState({toggleAlertDelete: false})}
                           handleDelete={() => this.deleteComment()}/>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        forumComment: state.forumComment.data,
        forumCommentLoading: state.forumComment.loading,
        forumCommentInitialized: state.forumComment.initialized,
        currentUser : state.currentUser.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForumComment,
    createForumComment,
    updateForumComment,
    deleteForumComment,
    resetForumComment
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditComment);